import { getZonedDate } from '@eika-infrastruktur/date';
import { RecurringPaymentActionType } from './actions';
import { recurringPaymentInitialState } from './state';
const recurringPaymentReducer = (state, action) => {
    switch (action.type) {
        case RecurringPaymentActionType.FROM_ACCOUNT_SELECTED:
            return {
                ...state,
                fromAccount: action.payload,
            };
        case RecurringPaymentActionType.TO_ACCOUNT_SELECTED:
            return {
                ...state,
                toAccount: action.payload,
            };
        case RecurringPaymentActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case RecurringPaymentActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case RecurringPaymentActionType.OWNTEXT:
            return {
                ...state,
                ownText: action.payload,
            };
        case RecurringPaymentActionType.FIRST_PAYMENT_DATE:
            return {
                ...state,
                firstPaymentDate: getZonedDate(action.payload),
            };
        case RecurringPaymentActionType.LAST_PAYMENT_DATE:
            return {
                ...state,
                lastPaymentDate: action.payload ? getZonedDate(action.payload) : undefined,
            };
        case RecurringPaymentActionType.FIRST_BANKING_DATE:
            return {
                ...state,
                firstBankingDate: action.payload,
                firstPaymentDate: action.payload,
            };
        case RecurringPaymentActionType.ONLY_BANKING_DATE:
            return {
                ...state,
                firstBankingDate: action.payload,
            };
        case RecurringPaymentActionType.PAYMENT_INTERVAL:
            return {
                ...state,
                paymentInterval: action.payload,
            };
        case RecurringPaymentActionType.RESET:
            return {
                ...recurringPaymentInitialState,
                firstBankingDate: state.firstBankingDate,
                firstPaymentDate: state.firstBankingDate,
            };
        case RecurringPaymentActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case RecurringPaymentActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        default:
            return state;
    }
};
export default recurringPaymentReducer;
//# sourceMappingURL=data:application/json;base64,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